import LazyLoad from 'vanilla-lazyload';

// Inizializza LazyLoad su tutte le pagine tranne Detail
const page = (document.body?.dataset.page ?? '').toLowerCase();

if (page !== 'detail') {
    const initLazyLoad = () => {
        (window as any).lazyLoadInstance = new LazyLoad({ elements_selector: '.lazy' });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLazyLoad);
    } else {
        // DOM già pronto (script caricato con defer o in fondo al body)
        initLazyLoad();
    }
}
